import { SET_SERVICE_PAGINATION } from "../ActionName/ActionName";

const initialState = {
    pagination : { page: 1, limit : 10, total : 0 },
    timestamp : Date.now()
}

const ServicePaginationReducer = (state = initialState, action) =>{
    switch(action.type){
        case SET_SERVICE_PAGINATION:
            return ({...state, pagination:action.value, timestamp:Date.now()})
        default:
            return state;
    }
}
export default ServicePaginationReducer;